// extracted by mini-css-extract-plugin
module.exports = {"loading":"App_loading__mxsze"};